import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 设置月度汇总考勤的考勤规则
import { setAttendanceSetting as _setAttendanceSetting, getAttendanceSetting } from 'api/Attendance/monthly-statistics';
// 考勤周期设置
import AttendanceCycleSettings from './attendance-cycle-settings';
export default {
  components: {
    AttendanceCycleSettings: AttendanceCycleSettings
  },
  data: function data() {
    return {
      activeName: '1',
      loading: false,
      form: {
        at_type: 1,
        // 1 按照班次设置时长折算 2 按照打卡次数计算
        miss_click_once: 1 // 员工缺卡1次时 1 仍记为全勤 2 记录为0.5天出勤 3 记录为0天出勤
      },

      AttendanceText: ''
    };
  },
  created: function created() {
    var _this = this;
    getAttendanceSetting().then(function (res) {
      _this.form = res.data;
    });
  },
  methods: {
    // 编辑考勤周期
    handleEdit: function handleEdit() {
      this.$refs.cycleSetting.visible = true;
    },
    // 考勤展示文案
    handlerText: function handlerText(attenText) {
      this.AttendanceText = attenText;
    },
    // 设置考勤
    setAttendanceSetting: function setAttendanceSetting() {
      var _this2 = this;
      this.$util.messageBox(this.$t('1970'), 'warning', function () {
        _this2.loading = true;
        _setAttendanceSetting(_this2.form).then(function () {
          _this2.$emit('close', 1);
        }).finally(function () {
          return _this2.loading = false;
        });
      });
    }
  }
};